// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Gsu9","container":"styles_container__1RPkS","title":"styles_title__1DSLC","wrapper":"styles_wrapper__3_7ON","answer":"styles_answer__DpQC9"};